import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guest',
  templateUrl: './guest.layout.html'
})
export class GuestLayout implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
